export enum TwoFactorMethod {
  application = 'application', // @Deprecated
  oneTimePassword = 'google', // @Deprecated
  authenticator = 'authenticator', // Please use this one for generic authenticators
  google = 'google',
  microsoft = 'microsoft',
  email = 'email',
  sms = 'sms',
}
